import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="prose max-w-none">
      <p className="text-lg font-semibold mb-4">시행일자: 2025년 8월 1일</p>
      
      <p className="mb-6">
        면접톡 면접 연습 서비스(이하 "본 서비스")는 이용자의 개인정보를 중요하게 생각하며, 개인정보보호법을 준수하고 있습니다.
      </p>

      <h3 className="text-xl font-bold mb-4">1. 개인정보의 수집 및 이용 목적</h3>
      <p className="mb-4">본 서비스는 다음과 같은 목적으로 개인정보를 처리합니다:</p>
      
      <h4 className="text-lg font-semibold mb-3">🎯 수집하는 정보</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li><strong>음성 데이터</strong>: 실시간 음성인식을 통한 텍스트 변환 (저장하지 않음)</li>
        <li><strong>접속 로그</strong>: 서비스 이용 통계 및 개선을 위한 익명 데이터</li>
        <li><strong>쿠키 정보</strong>: 웹사이트 이용 편의성 및 맞춤형 광고 제공</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">🚫 수집하지 않는 정보</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>개인 식별 정보 (이름, 연락처, 주소 등)</li>
        <li>음성 녹음 파일</li>
        <li>면접 답변 내용</li>
        <li>로그인 정보</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">2. 개인정보의 처리 방법</h3>
      
      <h4 className="text-lg font-semibold mb-3">🎤 음성 처리</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>브라우저의 Web Speech API를 통해 실시간으로 음성을 텍스트로 변환</li>
        <li>음성 데이터는 서버에 전송되지 않으며, 브라우저에서만 처리</li>
        <li>변환된 텍스트는 페이지 새로고침 시 자동 삭제</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">📊 통계 데이터</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Google Analytics를 통한 익명 방문 통계 수집</li>
        <li>개인을 식별할 수 없는 형태로만 수집</li>
        <li>서비스 개선 및 사용자 경험 향상 목적</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">🍪 쿠키 사용</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>필수 쿠키: 서비스 정상 작동을 위한 최소한의 쿠키</li>
        <li>분석 쿠키: Google Analytics 등을 통한 익명 통계</li>
        <li>광고 쿠키: Google AdSense를 통한 맞춤형 광고 제공</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">3. 개인정보의 보관 및 삭제</h3>
      
      <h4 className="text-lg font-semibold mb-3">⏰ 보관 기간</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>음성 데이터: 즉시 삭제 (저장하지 않음)</li>
        <li>통계 데이터: Google Analytics 정책에 따라 자동 관리</li>
        <li>쿠키: 브라우저 설정에 따라 관리</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">🗑️ 삭제 방법</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>브라우저 종료 시 세션 데이터 자동 삭제</li>
        <li>쿠키는 브라우저 설정에서 직접 삭제 가능</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">4. 제3자 서비스 이용</h3>
      
      <h4 className="text-lg font-semibold mb-3">🎵 AWS Polly (음성 합성)</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>질문 텍스트를 음성으로 변환</li>
        <li>사용자 데이터는 전송되지 않음</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">📈 Google Analytics</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>익명 방문 통계 수집</li>
        <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google 개인정보처리방침</a> 적용</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">📢 Google AdSense</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>맞춤형 광고 제공</li>
        <li><a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google 광고 개인정보보호</a> 적용</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">5. 이용자의 권리</h3>
      
      <h4 className="text-lg font-semibold mb-3">✅ 귀하의 권리</h4>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>쿠키 설정 변경 및 거부 권리</li>
        <li>개인정보 처리에 대한 동의 철회 권리</li>
        <li>관련 문의 및 불만 신고 권리</li>
      </ul>

      <h4 className="text-lg font-semibold mb-3">📞 문의처</h4>
      <ul className="list-disc pl-6 mb-6 space-y-1">
        <li>이메일: job1004jane@gmail.com</li>
        <li>개인정보보호 관련 문의사항이 있으시면 언제든 연락주세요</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">6. 개인정보처리방침의 변경</h3>
      <p className="mb-6">
        본 방침은 서비스 개선이나 법령 변경에 따라 수정될 수 있으며, 변경 시 웹사이트를 통해 공지하겠습니다.
      </p>

      <div className="border-t pt-4 mt-6">
        <p className="text-center font-semibold">최종 수정일: 2025년 8월 1일</p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;